import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TenantPackageApi } from '../api/tenantpackage.api';
import { switchMap, map } from 'rxjs/operators';
import { TenantPackage,TenantPackageData } from '../../../interfaces/masters/tenantpackage';

@Injectable()
export class TenantPackageService extends TenantPackageData {

  constructor(private api: TenantPackageApi) {
    super();
  }


  list(): Observable<TenantPackage[]> {
    return this.api.list();
  }


  tenantList(url:string): Observable<any[]> {
    return this.api.tenantList(url);
  }

  getById(url: string): Observable<TenantPackage>{
      return this.api.getById(url);
  }

  create(url: string, data: TenantPackage): Observable<TenantPackage> {
    return this.api.add(url,data);
  }
   createArray(url: string, data:TenantPackage[]): Observable<any> {
     debugger;
      return this.api.addArray(url,data);
    }

addPackage(url: string, data: any): Observable<TenantPackage> {
  debugger;
    return this.api.addPack(url,data);
    debugger;
  }
  update(url: string, data: TenantPackage): Observable<TenantPackage> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
